export const ActivationIncompleteTroubleshooting = () =>
    <div className="font-normal text-sm p-3 bg-blue-50 rounded">
        <h4 className="font-semibold">
            For efficient resolution of any system issues, please follow these steps:
        </h4>
        <h5 className="font-semibold mt-2">For Enphase systems,</h5>
        <ul className="mt-4 mb-4 list-decimal pl-5">
            <li>
                <span className="font-semibold">Log into</span> the <span className="font-semibold">Enphase
                    Enlighten Portal</span> at <a
                    href="https://enlighten.enphaseenergy.com/"
                    target="_blank"
                    rel="noreferrer"
                >https://enlighten.enphaseenergy.com/</a>, <span className="font-semibold">select</span> the
                warranty holder's site from the <span className="font-semibold">systems
                    list</span>, and <span className="font-semibold">navigate</span> to
                the <span className="font-semibold">Activations tab</span>.
            </li>
            <li>
                <span className="font-semibold">Confirm</span> all four stages of system activation in Enlighten
                have been completed.
            </li>
            <li>
                <span className="font-semibold">Revisit</span> each stage to ensure all checks are cleared.
            </li>
            <li>
                <span className="font-semibold">Contact Enphase support</span> for additional assistance if needed.
            </li>
        </ul>
        <h5 className="font-semibold">For SolarEdge Systems, </h5>
        <ul className="mt-4 list-decimal pl-5">
            <li>
                <span className="font-semibold">Log</span> into the <span className="font-semibold">SolarEdge
                    Monitoring Portal</span> at <a
                    href="https://monitoring.solaredge.com/solaredge-web/p/login"
                    target="_blank"
                    rel="noreferrer"
                >https://monitoring.solaredge.com/solaredge-web/p/login</a>..
            </li>
            <li>
                <span className="font-semibold">Locate</span> the associated warranty holder in
                the <span className="font-semibold">'Sites' list.</span>
            </li>
            <li>
                <span className="font-semibold">A Pending status</span> usually indicates that the system has not
                achieved PTO. <span className="font-semibold">Confirm</span> site connection details.
            </li>
        </ul>
    </div>
